import { FormControlLabel, Grid, Stack, Switch } from '@mui/material'
import type { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import InfoText from '@/components/dataDisplay/InfoText'
import { SITE_STEPS_FIELD_WIDTH } from '@/features/site/constants'

interface SiteActivationOrderSettingsDisplayProps {
  isTopPlacementPriority?: boolean
  onTopPlacementPriorityChange?: (isTopPriorityPlacement: boolean) => void
}

export const SiteActivationOrderSettingsDisplay = ({
  isTopPlacementPriority,
  onTopPlacementPriorityChange,
}: SiteActivationOrderSettingsDisplayProps) => {
  const { t } = useTranslation()

  function handleTopPriorityPlacementChange(evt: ChangeEvent<HTMLInputElement>) {
    const { checked } = evt.target

    onTopPlacementPriorityChange?.(checked)
  }

  return (
    <Grid container direction="column" gap={2}>
      <Grid size={{ md: 8, sm: 6 }}>
        <InfoText text={t('sites.activation_order_settings.form.info')} />
      </Grid>

      <Grid width={SITE_STEPS_FIELD_WIDTH}>
        <Stack flexDirection="column" gap={3}>
          <FormControlLabel
            control={<Switch checked={isTopPlacementPriority} onChange={handleTopPriorityPlacementChange} />}
            label={t('sites.activation_order_settings.form.is_top_placement_priority.label')}
          />
        </Stack>
      </Grid>
    </Grid>
  )
}
